module.exports = __webpack_public_path__ + "france24x24.png?88c879341947be806e033ada2650bf46";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logos/france24x24.png
// module id = 1036
// module chunks = 0